module.exports = __webpack_public_path__ + "img/order-confirmed.c2931a14.png";